module.exports = __webpack_public_path__ + "static/11-e09deb4f2aee8d2ed6b7a570ad598ff6.png";